import React, { useState, useEffect } from 'react';

const Switch = ({onchange , label , name , defaultValue}) => {
  const [value , setValue] = useState(0)
  const [check, setCheck] = useState(defaultValue);

  const handleChange = () => {
    setValue(value === 0 ? 1 : 0)
    onchange({name:name , value:value === 0 ? 1 : 0})
  }
  useEffect(() => {
    setCheck(defaultValue);
  }, [defaultValue]);

  return (
    <div>
      <label className="inline-flex items-center !text-gray-500 cursor-pointer">
        <input checked={check} onChange={() => handleChange()} type="checkbox" value="" className="sr-only peer "/>
          <div
            className="relative text-gray-500 w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          <span className="ms-3 text-sm font-medium !text-gray-500 dark:text-gray-300">{label}</span>
      </label>
    </div>
  );
};

export default Switch;
